import { useEffect, useState } from "react";

/** Current time, ticking every second only while `enabled`. */
const useNow = (enabled: boolean): number => {
	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		setNow(Date.now());
		if (!enabled) return undefined;

		const timer = setInterval(() => setNow(Date.now()), 1000);
		return () => clearInterval(timer);
	}, [enabled]);

	return now;
};

export default useNow;
